import useVirtualizedOptions from '@/storybook/components/FormCollection/hooks/useVirtualizedOptions';
import { SelectItem } from '@/types/ui';
import { useMemo } from 'react';

export type UseFloatingLabelVirtualizedOptionsParams<T> = {
  selectedOptions?: SelectItem<T>[];
  notSelectedOptions?: SelectItem<T>[];
  categoriesToDisplay: Array<{ category: string; index: number }>;
  noCategoryLabel: string;
  isCategoryCollapsed?: (categoryKey: string) => boolean;
};

export function useFloatingLabelVirtualizedOptions<T>({
  selectedOptions = [],
  notSelectedOptions = [],
  categoriesToDisplay,
  noCategoryLabel,
  isCategoryCollapsed,
}: UseFloatingLabelVirtualizedOptionsParams<T>) {
  const needsDivider = selectedOptions.length > 0 && notSelectedOptions.length > 0;

  const hasCategorizedOptions = useMemo(
    () => notSelectedOptions.some(opt => opt?.category != null),
    [notSelectedOptions],
  );

  const { virtualizedList, parentRef } = useVirtualizedOptions<T>({
    selectedOptions,
    notSelectedOptions,
    hasCategorizedOptions,
    categoriesToDisplay,
    includeDivider: needsDivider,
    noCategoryLabel,
    isCategoryCollapsed,
  });

  return {
    virtualizedList,
    parentRef,
    selectedOptions,
    notSelectedOptions,
  };
}
